import { styled } from '@mui/material/styles';
import BaseAccordion from '@components/BaseAccordion';
import { warm } from '@style/variables';

export const Accordion = styled(BaseAccordion)(
  ({ theme }) => `
  .MuiAccordionSummary-root {
    background-color: #423933;
    min-height: 48px !important;
    padding: 0 24px;
    &:focus-visible {
      background-color: ${warm[700]};
    }
    .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
      min-height: none !important;
    }
    & p {
      font-family: 'Knockout', sans-serif;
      font-size: 28px;
      text-transform: uppercase;
    }
    .Mui-expanded {
      min-height: 0 !important;
    }
  }
  .MuiAccordionSummary-content {
    margin: 0 !important;
  }
  .MuiAccordionDetails-root {
    padding: 0 !important;
    .attribute-row:nth-of-type(even) {
      min-height: none;
      ${theme.breakpoints.up('sm')} {
        background-color: #f5f4f1;
      }
    }
      .MuiOutlinedInput-root {
      width: 345px;
    }
    & p {
      margin-bottom: 0;
    }
  }
`,
);

export const DropdownWrapper = styled('div')(
  ({ theme }) => `
  font-family: 'Roboto', sans-serif;
  position: relative;
  width: 100%;
  padding-bottom: ${theme.spacing(2)};
  .MuiOutlinedInput-root {
   border: 2px #747778 solid;
 
  }
  .MuiSelect-select {
      text-align: left;
      padding: 8px !important;
      ${theme.breakpoints.up('lg')} {
        padding-left: 16px !important;
      }
  }
   .MuiOutlinedInput-root {
    border: 2px #747778 solid;
    width: 100%;
  }
  & svg {
    margin-right: ${theme.spacing(2)};
  }
`,
);
